import React, { useEffect, useState, useCallback } from "react";
import NavHeader from "../components/nav/NavHeader";
import Sidenav from "../components/nav/Sidemenu";
import { Link } from "react-router-dom";
import preloadimg from "../assets/img/preloader1.gif";
import NodataAvailable from "../assets/img/NoDataAvailable.jpg";
import {
  FaAngleDown,
  FaAngleUp,
  FaInfoCircle,
  FaRegChartBar,
  FaThLarge,
} from "react-icons/fa";
import UserInfo from "../components/auth/Getusers";
import LandingKPIReport from "../components/pageLayouts/LandingKPIReport";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import RankedTable from "../components/layout/RankedTable";
import { useAsync } from "../components/hooks/useAsync";
import { getreportsList } from "../components/services/FetchAPI";
import { getToken } from "../components/auth/authConfig";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "./Login";

const Home = () => {
  const [iconsD, setIconsD] = useState(true);
  const [iconsR, setIconsR] = useState(true);
  const [Tabvalue, setTabValue] = useState(0);
  const [reportView, setReportView] = useState("grid");
  const [passtoken, setPasstoken] = useState(null);

  // Get token on component mount
  useEffect(() => {
    const initToken = async () => {
      const token = await getToken();
      setPasstoken(token);
    };
    initToken();
  }, []);

  // Memoized callback to fetch reports
  const fetchReports = useCallback(() => {
    if (!passtoken) {
      return Promise.resolve(null); // Wait for token to be available
    }
    return getreportsList(passtoken);
  }, [passtoken]);

  const {
    loading,
    errorData,
    value: reportListData,
  } = useAsync(fetchReports, [passtoken]);

  useEffect(() => {
    document.title = "Home";
  }, [passtoken]);

  const toggleDept = () => {
    setIconsD((prev) => !prev);
  };

  const toggleReport = () => {
    setIconsR((prev) => !prev);
  };

  const homeMainStyle = {
    height: "auto",
    minHeight: "calc(100vh - 86px)",
    overflowY: "visible",
  };

  // Use reportListData
  const getClientsData = reportListData?.data;
  const reports             = getClientsData?.reports             || [];
  const assignedPersonas    = getClientsData?.assigned_personas   || [];
  const userGroupSet        = getClientsData?.userGroupSet        || {};
  const userInfo            = getClientsData?.userInfo            || {};
  const visuals             = getClientsData?.visuals             || [];

  // Store user group and RL type in localStorage
  if (getClientsData?.userGroupId) {
    localStorage.setItem("userGroup", getClientsData?.userGroupId);
  }
  if (getClientsData?.defaultRlType) {
    localStorage.setItem("RLTYPE", getClientsData?.defaultRlType);
  }
  if (getClientsData?.userGroupSet) {
    localStorage.setItem("userGroupSet", JSON.stringify(getClientsData.userGroupSet));
  }
  if (userInfo?.userType) {
    localStorage.setItem("userType", userInfo.userType);
  }

  return (
    <div>
      <AuthenticatedTemplate>
        <NavHeader
          rlTypeData={getClientsData?.rlType}
          defaulRLData={getClientsData?.defaultRlType}
        />
        <Sidenav />
        {getClientsData !== null && (
          <div className="relative px-4 md:px-8 pb-16" id="main" style={homeMainStyle}>
            <div
              className="pointer-events-none absolute inset-0 opacity-70"
              aria-hidden="true"
            />
            {loading && (
              <div className="fixed inset-0 z-[99999] grid place-items-center content-center bg-black/80 text-white">
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Loading Home page, please wait...</span>
              </div>
            )}

            {!loading && getClientsData !== undefined && !errorData && (
              <>
                <div className="relative z-10">
                  <UserInfo />
                </div>

                <section className="relative z-10 mt-2 rounded-2xl border border-slate-200/80 bg-white/90 p-4 md:p-6 shadow-sm backdrop-blur">
                  <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
                    <div>
                      <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Active Workspace</p>
                      <h1 className="text-xl md:text-2xl font-extrabold text-slate-900">
                        {/* {assignedPersonas[Tabvalue]?.name || getClientsData?.userGroupName} */}
                        Visual Insights for Your Workspace
                      </h1>
                      {assignedPersonas.length > 1 && (
                        <p className="text-[11px] text-slate-400 mt-0.5">
                          {assignedPersonas.length} personas assigned
                        </p>
                      )}
                    </div>

                    <button
                      type="button"
                      onClick={toggleDept}
                      className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
                    >
                      <FaThLarge className="text-slate-500" />
                      {iconsD ? (
                        <span>
                          Collapse <FaAngleUp className="ml-1 inline text-slate-500" />
                        </span>
                      ) : (
                        <span>
                          Expand <FaAngleDown className="ml-1 inline text-slate-500" />
                        </span>
                      )}
                    </button>
                  </div>

                  <div className={`${iconsD ? "block" : "hidden"}`}>
                    {iconsD && (
                      <div id="Dept_div_id">
                        <LandingKPIReport
                          rlType={getClientsData?.rlType}
                          defaultRL={getClientsData?.defaultRlType}
                          assignedPersonas={assignedPersonas}
                          userGroupSet={userGroupSet}
                          visuals={visuals}
                        />
                      </div>
                    )}
                  </div>

                  {!iconsD && (
                    <p className="text-sm text-slate-500">
                      Please Toggle the Right icons for view all the Dashboard
                    </p>
                  )}
                </section>

                <section className="relative z-10 mt-5 overflow-hidden rounded-2xl border border-slate-200/80 bg-white/95 shadow-sm backdrop-blur">
                  <div
                    className="pointer-events-none absolute -right-12 -top-12 h-44 w-44 rounded-full opacity-30 blur-2xl"
                    style={{ background: "color-mix(in srgb, var(--app-icon-color, #A70E13) 26%, white)" }}
                    aria-hidden="true"
                  />

                  {/* Persona tabs + view toggle header */}
                  <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 px-4 pt-3">
                    <div className="flex flex-wrap items-center gap-1 overflow-x-auto">
                      {assignedPersonas.length > 0 ? assignedPersonas.map((persona, idx) => (
                        <button
                          key={persona.id}
                          type="button"
                          onClick={() => setTabValue(idx)}
                          className={`whitespace-nowrap rounded-t-lg px-4 py-2 text-xs font-semibold transition-colors border-b-2 ${
                            Tabvalue === idx
                              ? "border-[var(--app-icon-color,#A70E13)] text-[var(--app-icon-color,#A70E13)] bg-white"
                              : "border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50"
                          }`}
                        >
                          {persona.name}
                          <span className={`ml-1.5 rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
                            Tabvalue === idx ? "bg-red-50 text-[var(--app-icon-color,#A70E13)]" : "bg-slate-100 text-slate-500"
                          }`}>
                            {persona.reports?.length ?? 0}
                          </span>
                        </button>
                      )) : (
                        <span className="px-4 py-2 text-xs font-semibold text-slate-700">Reports</span>
                      )}
                    </div>
                    <div className="flex items-center gap-2 pb-1">
                      <div className="inline-flex rounded-lg border border-slate-200 bg-white p-1">
                        <button type="button" onClick={() => setReportView("grid")}
                          className={`rounded-md px-3 py-1.5 text-xs font-semibold transition ${reportView === "grid" ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
                          Grid
                        </button>
                        <button type="button" onClick={() => setReportView("table")}
                          className={`rounded-md px-3 py-1.5 text-xs font-semibold transition ${reportView === "table" ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
                          Table
                        </button>
                      </div>
                      <button type="button" onClick={toggleReport}
                        className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">
                        <FaThLarge className="text-slate-500" />
                        {iconsR ? <span>Collapse <FaAngleUp className="ml-1 inline text-slate-500" /></span>
                                : <span>Expand <FaAngleDown className="ml-1 inline text-slate-500" /></span>}
                      </button>
                    </div>
                  </div>

                  {/* Active persona report list */}
                  {(() => {
                    const activePersona = assignedPersonas[Tabvalue];
                    const activeReports = activePersona?.reports || reports;
                    return (
                      <div className={`p-4 md:p-6 ${iconsR ? "block" : "hidden"}`}>
                        {iconsR && reportView === "grid" && (
                          <div id="Report_div_id" className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                            {activeReports.map((items, index) => (
                              <Link key={index}
                                to={items[0] === 118 ? `/LIMS/${items[0]}` : `/reports/${items[0]}/view`}
                                className="group block no-underline">
                                <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white px-4 pb-4 pt-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                                  style={{ animationDelay: `${index * 60}ms` }}>
                                  <div className="absolute inset-x-0 top-0 h-1.5" style={{ background: "linear-gradient(90deg, var(--app-icon-color, #A70E13), color-mix(in srgb, var(--app-icon-color, #A70E13) 65%, white))" }} aria-hidden="true" />
                                  <div className="relative flex items-start justify-between gap-3">
                                    <div className="grid h-11 w-11 place-items-center rounded-xl" style={{ background: "color-mix(in srgb, var(--app-icon-color, #A70E13) 14%, white)" }} aria-hidden="true">
                                      <FaRegChartBar color="var(--app-icon-color)" fontSize={20} />
                                    </div>
                                    <span className="rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500">Report</span>
                                  </div>
                                  <div className="relative mt-4">
                                    <h3 className="line-clamp-2 text-sm font-bold leading-5 text-slate-900">{items[1]}</h3>
                                    <p className="mt-2 text-xs leading-5 text-slate-500">Open interactive dashboard and review visual insights.</p>
                                    <div className="mt-2 flex flex-wrap items-center gap-2 text-[10px] text-slate-400">
                                      {items[9] && <span>{items[9]}</span>}
                                      {items[8] && <span>· {items[8]}</span>}
                                      {items[10] === true
                                        ? <span className="rounded-full bg-green-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase text-green-700 border border-green-200">RLS</span>
                                        : <span className="rounded-full bg-slate-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase text-slate-400 border border-slate-200">No RLS</span>}
                                    </div>
                                  </div>
                                  <div className="relative mt-4 flex items-center justify-between">
                                    <span className="text-xs font-semibold" style={{ color: "var(--app-icon-color, #A70E13)" }}>View Report</span>
                                    <span className="text-sm text-slate-400 transition-transform duration-300 group-hover:translate-x-0.5">-&gt;</span>
                                  </div>
                                  <div className="absolute right-3 top-3 z-10">
                                    <OverlayTrigger transition={false} overlay={<Tooltip id="tooltip">{items[4] === "" ? items[1] : items[4]}</Tooltip>}>
                                      <span style={{ transition: "none" }} className="inline-block">
                                        <FaInfoCircle style={{ opacity: "0.72", transition: "none" }} color="var(--app-icon-color, #A70E13)" />
                                      </span>
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}

                        {iconsR && reportView === "table" && (
                          <RankedTable
                            columns={[{ label: "Report" }, { label: "Description" }, { label: "Created" }, { label: "RLS", align: "center" }, { label: "Action", align: "right" }]}
                            rows={activeReports}
                            emptyText="No reports available."
                            renderRow={(items) => (
                              <>
                                <td className="px-4 py-3 text-sm font-semibold text-slate-800">{items[1]}</td>
                                <td className="px-4 py-3 text-sm text-slate-500">
                                  <OverlayTrigger transition={false} overlay={<Tooltip id={`report-desc-${items[0]}`}>{items[4] === "" ? items[1] : items[4]}</Tooltip>}>
                                    <span className="line-clamp-1 inline-block max-w-[520px] align-middle">{items[4] === "" ? "Open interactive dashboard" : items[4]}</span>
                                  </OverlayTrigger>
                                </td>
                                <td className="px-4 py-3 text-xs text-slate-500">
                                  <div>{items[9] || "—"}</div>
                                  <div className="text-slate-400">{items[8] || ""}</div>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  {items[10] === true
                                    ? <span className="rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-semibold text-green-700 border border-green-200">RLS</span>
                                    : <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-400 border border-slate-200">No RLS</span>}
                                </td>
                                <td className="px-4 py-3 text-right">
                                  <Link to={items[0] === 118 ? `/LIMS/${items[0]}` : `/reports/${items[0]}/view`}
                                    className="inline-flex rounded-md border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 no-underline hover:bg-slate-100">
                                    Open
                                  </Link>
                                </td>
                              </>
                            )}
                          />
                        )}
                      </div>
                    );
                  })()}

                  {!iconsR && (
                    <p className="p-4 text-sm text-slate-500">Please Toggle the Right icons for Report to view all Reports</p>
                  )}
                </section>

              </>
            )}

            {!loading && getClientsData === undefined && !errorData && (
              <div className="relative z-10 grid place-items-center text-center">
                <img
                  style={{ width: "400px" }}
                  src={NodataAvailable}
                  alt="Nodata"
                  className="NoDataHome"
                />
                <div style={{ fontSize: "24px" }}>
                  There is no data available
                </div>
              </div>
            )}

            {errorData && (
              <div className="relative z-10 rounded-xl border border-rose-200 bg-rose-50 p-4 text-rose-700">
                <div>There is Some error, {errorData}</div>
                <div>Plase Try after sometime</div>
              </div>
            )}
          </div>
        )}

        {getClientsData === null && (
          <div className="relative px-4 md:px-8 pb-16" id="main" style={homeMainStyle}>
            <div className="grid place-items-center text-center">
              <img
                style={{ width: "400px" }}
                src={NodataAvailable}
                alt="Nodata"
                className="NoDataHome"
              />
              <div style={{ fontSize: "24px" }}>
                There is no report associated with this persona, Kindly reach
                out to the admin for further details and resolution.
              </div>
            </div>
 
          </div>
        )}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Home;
